import React from 'react';
import {ThemeProvider} from '@material-ui/styles';
import {useSelector} from 'react-redux';

function FusePageCardedHeader(props)
{
    const mainThemeLight = useSelector(({fuse}) => fuse.settings.mainThemeLight);

    return (
        <div className={props.classes.header}>
            {props.header && (
                <ThemeProvider theme={mainThemeLight}>
                    {props.header}
                </ThemeProvider>
            )}
        </div>
    )
}

export default FusePageCardedHeader;
